export const actionTypes = {
  REQUEST_START: 'TAPS.DOCUMENT_TYPES.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.DOCUMENT_TYPES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.DOCUMENT_TYPES.REQUEST_FAILURE',
  RESET_DOCUMENT_TYPES: 'TAPS.DOCUMENT_TYPES.RESET_DOC_TYPES',
};

export function startRequest(id) {
  return {
    type: actionTypes.REQUEST_START,
    payload: id,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function resetDocumentTypes() {
  return {
    type: actionTypes.RESET_DOCUMENT_TYPES,
  };
}
